import React from 'react';
import { Link } from 'react-router-dom';
import { useSchool } from '../contexts/SchoolContext';
import Seo, { faqJsonLd } from '../seo/Seo';
import './ContentPage.css';

// Questions and answers approved by the school (School Settings). Nothing is shown that the school has not entered.
const Faq = () => {
  const { settings } = useSchool();
  const faqs = settings.faqs ?? [];

  return (
    <div className="content-page">
      {faqs.length > 0 && <Seo path="/faq" jsonLd={faqJsonLd(faqs)} />}
      <section className="section">
        <div className="container content-container">
          <h1>Frequently Asked Questions</h1>
          {faqs.length === 0 ? (
            <div className="content-empty">
              <p>Answers to common questions are being prepared.</p>
              <p>
                In the meantime, please <Link to="/contact?type=admissions">send us your question</Link>
                {settings.phones.length > 0 && (
                  <> or call <a href={`tel:${settings.phones[0].tel}`}>{settings.phones[0].display}</a></>
                )}
                .
              </p>
            </div>
          ) : (
            <div className="faq-list">
              {faqs.map((item, i) => (
                <details key={i} className="faq-item">
                  <summary>{item.question}</summary>
                  <p>{item.answer}</p>
                </details>
              ))}
            </div>
          )}
          <p className="content-more">
            Still have a question? <Link to="/contact?type=admissions">Contact the admissions office</Link>.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Faq;
